import { cn } from '@/lib/utils';
import type { ActivityOverviewStatusFilter } from '@sparkapp/shared-types';

interface StatusFilterProps {
  value: ActivityOverviewStatusFilter;
  onChange: (status: ActivityOverviewStatusFilter) => void;
}

const OPTIONS: Array<{ value: ActivityOverviewStatusFilter; label: string }> = [
  { value: 'published', label: 'Published' },
  { value: 'draft', label: 'Draft' },
  { value: 'unpublished', label: 'Unpublished' },
  { value: 'archived', label: 'Archived' },
  { value: 'all', label: 'All (excl. archived)' },
];

/**
 * Segmented status filter. Applies to the domain tiles and all breakdowns;
 * the header stat cards always show unfiltered counts.
 */
export function StatusFilter({ value, onChange }: StatusFilterProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-caption text-pine-ink-soft mr-1">Status filter:</span>
      <div className="inline-flex rounded-pine-input border border-pine-line bg-pine-card p-1 gap-1">
        {OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={cn(
              'px-3 py-1.5 rounded-pine-input text-sm font-medium transition-colors',
              value === option.value
                ? 'bg-pine-active-item text-pine-pine'
                : 'text-pine-ink-soft hover:bg-pine-hover-item'
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
